var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-detail"},[(_vm.currentStep)?_c(_vm.currentStep.com,{ref:"content",tag:"components",attrs:{"data":_vm.currentStep.data,"onFinish":_vm.forceNextStep}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }